import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { formatCurrency } from '@/utils/constants';

export const KanbanColumnKPIFooter = ({ totalAmount }) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				position: 'sticky',
				bottom: 0,
				zIndex: 10,
				minHeight: '40px',
				bgcolor: theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 1,
				px: 1.5,
				py: 0.5,
				borderTop: `1px solid ${theme.palette.divider}`,
				flexShrink: 0,
				boxShadow: '0 -2px 4px rgba(0,0,0,0.05)',
				width: '100%',
				boxSizing: 'border-box',
			}}
		>
			<Typography
				sx={{
					fontSize: '11px',
					fontWeight: 600,
					color: 'text.secondary',
					flexShrink: 0,
				}}
			>
				Total Amount
			</Typography>
			<Typography
				sx={{
					fontSize: '11px',
					fontWeight: 600,
					color: theme.palette.primary.main,
					minWidth: 0,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					textAlign: 'right',
				}}
				title={formatCurrency({ num: totalAmount, showDecimal: true })}
			>
				{formatCurrency({ num: totalAmount, showDecimal: true })}
			</Typography>
		</Box>
	);
};
